(() => {
  const root = document.querySelector('.cmq');
  if (!root) return;
  const normalize = value => value.normalize('NFKC').replace(/[‘’]/g, "'").replace(/\s+/g, ' ').trim().toLowerCase();
  const questions = new Set([...root.querySelectorAll('summary > span:first-child')].map(node => normalize(node.textContent)));
  const mergeLegacyDisplay = () => {
    document.querySelectorAll('.geo-faq').forEach(block => {
      const headings = [...block.querySelectorAll('h3')];
      if (headings.length && headings.every(heading => questions.has(normalize(heading.textContent)))) {
        block.hidden = true;
        block.dataset.cmqMerged = 'true';
      }
    });
  };
  mergeLegacyDisplay();
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      mergeLegacyDisplay();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
